module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_9005.e81ff977.png";